import axios from '@/libs/axios'
import { eventBus } from '@/main'

class WebSocketManager {
  constructor() {
    if (!WebSocketManager.instance) {
      this.socket = null;
      this.url = '';
      this.reconnectInterval = 1000; // milliseconds
      WebSocketManager.instance = this;
    }

    return WebSocketManager.instance;
  }

   connect(url) {
    this.url = url;
    this._connect();
  }

  async _getToken() {
     const response = await axios.get('wsGetToken');
     if (response.status === 200) {
       return response.data.ws_token;
     }
     return null;
  }

   _connect() {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      this._getToken().then(token => {
        if (token) {
          this.socket = new WebSocket(this.url + `?token=${token}`);
          this.socket.onopen = () => {
            console.log('WebSocket connection opened');
            this.reconnectInterval = 1000;
          };

          this.socket.onclose = () => {
            console.log('WebSocket connection closed, attempting to reconnect');
            this._reconnect();
          };

          this.socket.onmessage = message => {
            const msg = JSON.parse(message.data)
            eventBus.$emit(msg.type, msg)
          }
          this.socket.onerror = error => console.error('WebSocket error:', error)
        }
      })
    }
  }

  _reconnect() {
    setTimeout(() => {
      console.log(`Reconnecting in ${this.reconnectInterval / 1000} seconds...`);
      this._connect();
      this.reconnectInterval = Math.min(this.reconnectInterval * 2, 30000); // Exponential backoff, max 30 seconds
    }, this.reconnectInterval);
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(data);
    } else {
      console.error('WebSocket is not open');
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default new WebSocketManager();
